import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { doc, getDoc } from 'firebase/firestore'
import { useBackendStore } from './backend'

export const useSiteConfigStore = defineStore('siteConfig', () => {
  // State
  const config = ref({})

  // Getters
  const getConfig = computed(() => config.value ? config.value : {})
  const verbiage = computed(() => config.value.verbiage ? config.value.verbiage : {})
  const clientResourcesUrl = computed(() =>
    `https://firebasestorage.googleapis.com/v0/b/${import.meta.env.VITE_FIREBASE_STORAGE_BUCKET}/o/client%2F`
  )

  // Actions
  async function fetchConfig() {
    try {
      const backendStore = useBackendStore()
      const db = backendStore.db
      const configRef = doc(db, 'configuration', 'client')
      const docSnap = await getDoc(configRef)
      if (docSnap.exists()) {
        config.value = docSnap.data()
      }
    } catch (error) {
      console.error('Error fetching configuration:', error)
    }
  }

  return {
    // State
    config,

    // Getters
    config: getConfig,
    verbiage,
    clientResourcesUrl,

    // Actions
    fetchConfig
  }
})
